
import React from 'react';
import { Box, Typography, IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Drawer, useMediaQuery, useTheme } from '@mui/material';
import { 
    Home as HomeIcon, 
    Create as CreateIcon, 
    EmojiObjects as EmojiObjectsIcon, 
    Equalizer as EqualizerIcon, 
    Group as GroupIcon,
    AccountCircle,
    ExitToApp as LogoutIcon,
    History as BillingIcon,
    Menu as MenuIcon
} from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import BrandingLogo from "../../../../components/BrandingLogo/BrandingLogo.comp";
import { logoutUser } from '../../../../services/auth.service';

const TeacherDashboardLayout = ({ children, classes, activeTab, headerTitle }) => {
    const history = useHistory();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);
    const isMenuOpen = Boolean(anchorEl);

    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const toggleDrawer = (open) => () => {
        setIsDrawerOpen(open);
    };

    const navItems = [
        { icon: <HomeIcon />, text: 'Home', path: '/dq_pro/teacher-dashboard', key: 'home' },
        { icon: <CreateIcon />, text: 'Create', key: 'create' },
        { 
            icon: <EmojiObjectsIcon />, 
            text: 'Your Creations', 
            key: 'creations',
            subItems: ['Baseline Assessments', 'Learning Programs'] 
        },
        { icon: <EqualizerIcon />, text: 'Data & Insights', key: 'insights' },
        { icon: <GroupIcon />, text: 'Your Classes', path: '/dq_pro/teacher-dashboard/classes', key: 'classes' },
    ];

    const SidebarContent = () => (
        <>
            <Box className={classes.sidebarLogoContainer}>
                <BrandingLogo height={36} />
            </Box>
            <Box className={classes.navItems}>
                {navItems.map((item, idx) => (
                    <React.Fragment key={idx}>
                        <Box 
                            className={`${classes.navItem} ${activeTab === item.key ? classes.navItemActive : ''}`}
                            onClick={() => {
                                if (item.path) {
                                    history.push(item.path);
                                    setIsDrawerOpen(false);
                                }
                            }}
                        >
                            {item.icon}
                            <Typography className={classes.navText}>{item.text}</Typography>
                        </Box>
                        {item.subItems && item.subItems.map((sub, sIdx) => (
                            <Box key={sIdx} className={classes.subNav}>
                                {sub}
                            </Box>
                        ))}
                    </React.Fragment>
                ))}
            </Box>
        </>
    );

    return (
        <Box className={classes.root}>
            {/* Desktop Sidebar */}
            {!isMobile && (
                <Box className={classes.sidebar}>
                    <SidebarContent />
                </Box>
            )}

            {/* Mobile Drawer */}
            <Drawer 
                anchor="left" 
                open={isDrawerOpen} 
                onClose={toggleDrawer(false)}
                PaperProps={{
                    sx: {
                        transition: '0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                        width: '280px',
                        background: 'linear-gradient(180deg, #f54814 0%, #FF8A00 100%)',
                        color: '#fff',
                        border: 'none',
                    }
                }}
            >
                <SidebarContent />
            </Drawer>

            {/* Main Content Area */}
            <Box className={classes.mainContent}>
                <Box className={classes.header}>
                    {isMobile && (
                        <>
                            <IconButton 
                                onClick={toggleDrawer(true)} 
                                sx={{ position: 'absolute', left: '15px', color: '#F15A24', top: '50%', transform: 'translateY(-50%)' }}
                            >
                                <MenuIcon fontSize="large" />
                            </IconButton>
                        </>
                    )}
                    <Typography className={classes.headerTitle}>{headerTitle}</Typography>
                    <IconButton 
                        className={classes.profileIconBtn}
                        onClick={handleProfileMenuOpen}
                    >
                        <AccountCircle className={classes.profileIcon} />
                    </IconButton>

                    <Menu
                        anchorEl={anchorEl}
                        open={isMenuOpen}
                        onClose={handleMenuClose}
                        onClick={handleMenuClose}
                        PaperProps={{
                            elevation: 0,
                            sx: {
                                overflow: 'visible',
                                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.1))',
                                mt: 1.5,
                                borderRadius: '15px',
                                border: '1px solid #eee',
                            },
                        }}
                        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                    >
                        <MenuItem onClick={() => { handleMenuClose(); history.push('/dq_pro/invoices/list'); }}>
                            <ListItemIcon sx={{ color: '#F15A24' }}>
                                <BillingIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText primary="Billing History" primaryTypographyProps={{ style: { fontWeight: 600, fontSize: '14px' } }} />
                        </MenuItem>
                        <MenuItem onClick={async () => { handleMenuClose(); await logoutUser(); }}> //TODO: remove localStorage Keys here at logout
                            <ListItemIcon sx={{ color: '#F15A24' }}>
                                <LogoutIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText primary="Logout" primaryTypographyProps={{ style: { fontWeight: 600, fontSize: '14px' } }} />
                        </MenuItem>
                    </Menu>
                </Box>
                
                {children}
            </Box>
        </Box>
    );
};

export default TeacherDashboardLayout;
